var _desc, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc1"
  }, "Created with Fabric.js 3.1.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.991243,0,0,2.991243,512.27954,519.8114)",
    id: "logo-logo"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6202433,0,0,-3.6202433,-115.44823,-67.797748)",
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#231f20",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    paintOrder: "stroke",
    transform: "translate(-0.2015,-0.01)",
    d: "M 0,0 0.222,-0.03 0.403,0.05 Z",
    strokeLinecap: "round",
    id: "path1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6202433,0,0,-3.6202433,-15.761272,-79.412932)",
    id: "g2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#00aeef",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    paintOrder: "stroke",
    transform: "translate(16.4265,3.6395)",
    d: "m 0,0 -0.222,0.029 -58.96,7.748 20.67,-22.833 64.841,11.597 z",
    strokeLinecap: "round",
    id: "path2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6202433,0,0,-3.6202433,76.630232,27.190923)",
    id: "g3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#0b3c60",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    paintOrder: "stroke",
    transform: "translate(-25.942,-5.8875)",
    d: "M 0,0 18.069,-19.954 51.884,31.729 Z",
    strokeLinecap: "round",
    id: "path3"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6202433,0,0,-3.6202433,42.619133,-18.223218)",
    id: "g4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "#1b75bc",
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    paintOrder: "stroke",
    transform: "translate(-35.165,2.1285)",
    d: "m 0,0 16.397,-18.108 53.933,31.94 -0.142,0.019 z",
    strokeLinecap: "round",
    id: "path4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c00a9d333cddd4c0155319abf9a55f7b.svg";
export { ForwardRef as ReactComponent };